import * as React from 'react'
import PropsTable from '../props-section/props-table.component'
import PropsSection from '../props-section/props-section.component'
import SandboxByKey from '../../sandboxes/sandbox-by-key.component'

export type WidgetKeyValueProps = {
  keyValue?: GatsbyTypes.Maybe<GatsbyTypes.keyValueFragment>
}

const WidgetKeyValue: React.FC<WidgetKeyValueProps> = ({ keyValue }) => {
  if (!keyValue) return null
  switch (keyValue.type) {
    case 'PropsTable':
      return keyValue.value ? <PropsTable component={keyValue.value} /> : null
    case 'PropsSection':
      return keyValue.value ? <PropsSection component={keyValue.value} defaultComponent={keyValue.key || 'div'} /> : null
    case 'Sandbox':
      return <SandboxByKey sandboxKey={keyValue.value} />
    default:
      return (
        <div>
          {keyValue.type} | {keyValue.key} | {keyValue.value}
        </div>
      )
  }
}

export default React.memo(WidgetKeyValue)
